import { useState } from 'react'
import { Combobox } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
import { Country, allCountries } from '../typesAndConsts'
  
export default function CountrySelector({onCountryChange}:{onCountryChange:(c:Country)=>void}) {
    
    const [query, setQuery] = useState('')
    const [selectedCountry, setSelectedCountry] = useState<Country>(allCountries[0])

    const filteredCounties = query === '' ? allCountries : allCountries.filter((country) => {
        return country.label.toLowerCase().includes(query.toLowerCase())
    })

    const setCountry = (country:Country) => {
        setSelectedCountry(country)
        onCountryChange(country)
    }

    return (
        <Combobox as="div" value={selectedCountry} onChange={setCountry}>
            <div className="relative mt-2">
                <Combobox.Input
                    className="w-full rounded-md border-0 bg-white py-1.5 pl-3 pr-12 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    onChange={(event) => setQuery(event.target.value)}
                    displayValue={(country:Country) => country?.label}
                />
                <Combobox.Button className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
                    <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                </Combobox.Button>

                {filteredCounties.length > 0 && (

                    <Combobox.Options className="absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                        
                        {filteredCounties.map((country, index) => (
                            <Combobox.Option
                                key={index}
                                value={country}
                                className={({ active }) => `relative cursor-default select-none py-2 pl-3 pr-9' ${active ? 'bg-indigo-600 text-white' : 'text-gray-900'}`}
                            >
                                {({ active, selected }) => (
                                    <>
                                        <div className="flex items-center">
                                            <img src={country.imageUrl} alt="" className="h-6 w-6 flex-shrink-0 rounded-full" />
                                            <span className={`ml-3 truncate ${selected ? 'font-semibold':''}`}>{country.label}</span>
                                        </div>

                                        {selected && (
                                            <span className={`absolute inset-y-0 right-0 flex items-center pr-4 ${active ? 'text-white' : 'text-indigo-600'}`}>
                                                <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                            </span>
                                        )}
                                    </>
                                )}
                            </Combobox.Option>
                        ))}
                    </Combobox.Options>
                )}
            </div>
        </Combobox>
    )
}